<template>
  <div class="nav-link">
    <p class="title-4 text-grey-900 m-0">
      {{ t('navbar.greeting') }} {{ userName }}
    </p>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ComputedRef } from 'vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  // Store
  import { useStore } from 'vuex'
  const store = useStore()

  // Computed
  const userName: ComputedRef<string> = computed(() => {
    const { user } = store.state.auth
    if (!user) return ''

    const MAX_USER_LENGTH = 20
    const userName = `${user.first_name} ${user.last_name}`
    return userName.substring(0, MAX_USER_LENGTH)
  })
</script>
